import { render, staticRenderFns } from "./segmentDetails.vue?vue&type=template&id=a871c412&scoped=true&lang=pug"
import script from "./segmentDetails.vue?vue&type=script&lang=js"
export * from "./segmentDetails.vue?vue&type=script&lang=js"
import style0 from "./segmentDetails.vue?vue&type=style&index=0&id=a871c412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a871c412",
  null
  
)

export default component.exports